export default function setSixAM(date, hour, minutes) {
    date.setHours(hour);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0); 
}